import React, { useState, useEffect } from 'react';
import { getSmsQueueStatusInPastXHours } from 'react-scale/corp/lib/api/growth';
import { Banner } from '@scale/scaleui';
import SAlert from 'react-s-alert';

const QueueWarning: React.FC = () => {
  const [percentage, setPercentage] = useState<number>(0);
  const [estimatedQueuedCount, setEstimatedQueuedCount] = useState<number>(0);
  const [estimatedQueueTimeMinutes, setEstimatedQueueTimeMinutes] = useState<number>(0);

  useEffect(() => {
    const fetchSmsQueueStatus = async () => {
      try {
        const res = await getSmsQueueStatusInPastXHours(3);
        setPercentage(res.percentage);
        setEstimatedQueuedCount(res.estimatedQueuedCount);
        setEstimatedQueueTimeMinutes(res.estimatedQueueTimeMinutes);
      } catch (err) {
        SAlert.error(
          `Failed to fetch SMS queue status: ${err.message}. There might be a significant SMS sending queue, 
          and you may not receive test SMS messages. Please check the Twilio console for the exact number of messages in the queue. 
          Post in #growth-eng-external if you need assistance.`,
        );
      }
    };

    fetchSmsQueueStatus();
  }, []);

  return (
    <>
      {percentage > 3 && estimatedQueuedCount > 100 ? (
        <Banner
          variant="warning"
          title="Possibly Large SMS Queue Pending"
          subtitle={`There are approximately ${estimatedQueuedCount} SMS messages in the queue. It will take approximately 
          ${estimatedQueueTimeMinutes} minutes to clear the queue. You may not receive test SMS messages as they will be queued.
          Please check back later if you do not receive the test SMS messages. For the exact number of messages in the queue, visit the Twilio console. Post in #growth-eng-external if you need assistance.`}
        />
      ) : null}
    </>
  );
};

export default QueueWarning;
